import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { setAddOperationsToTimeline } from '../store/quickActions.actions'
import { resetState } from '../../procedures/operations/store/operations.actions'
import { addOperationsItem } from '../../timeline/store/timeline.actions'
import { OperationsConstants } from '../../procedures/operations/store/operations.constants'

export function* saveOperationsQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addOperationsToTimeline } = quickActionsObject
  if (addOperationsToTimeline) {
    yield put(addOperationsItem())
    yield put(setAddOperationsToTimeline(false))
    yield put(resetState())
  }
}

export function* saveOperationsQuickActionTimeLineRowSaga() {
  yield takeLatest([OperationsConstants.SET_ADD_TO_TIMELINE], saveOperationsQuickActionTimeLineRow)
}
